import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const ProtectedRoute = ({ element, allowedRoles }) => {
  const { accounts } = useMsal();
  const [userRoles, setUserRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (accounts.length > 0) {
      const tokenRoles = accounts[0]?.idTokenClaims?.roles || [];
      setUserRoles(tokenRoles.map((role) => role.toLowerCase()));
    } else {
      setUserRoles([]);
    }
    setIsLoading(false);
  }, [accounts]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '200px',
        fontSize: '16px' 
      }}>
        Loading...
      </div>
    );
  }

  if (!allowedRoles || allowedRoles.length === 0) {
    return element;
  }

  const hasAccess = allowedRoles
    .map((role) => role.toLowerCase())
    .some((role) => userRoles.includes(role));

  return hasAccess ? element : <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;